import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDiscord } from "../../context/DiscordContext";
import { api } from "@/lib/api";

const DISCORD_INVITE = "https://discord.gg/zdE2kWsStf";

export default function Footer() {
  const { isAdmin } = useDiscord();
  const [pending, setPending] = useState(0);

  useEffect(() => {
    if (!isAdmin) {
      setPending(0);
      return;
    }
    let cancelled = false;
    const load = () =>
      api
        .get("/whitelist/applications/count")
        .then((res) => {
          if (!cancelled) setPending(res.data?.pending || 0);
        })
        .catch(() => {});
    load();
    // poll every 60s while the admin has the site open
    const t = setInterval(load, 60_000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [isAdmin]);

  return (
    <footer className="border-t border-[#283524] bg-[#0D110C] py-12 relative">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 border border-[#5C6B51] flex items-center justify-center bg-[#161D14]">
              <span className="font-display text-[#C0A875] text-xl font-bold leading-none">W</span>
            </div>
            <span className="font-display text-[#E2E4DF] text-xl uppercase tracking-wider">
              What's Left of Us
            </span>
          </div>
          <p className="text-[#8D9A87] text-sm max-w-md leading-relaxed">
            A Project Zomboid multiplayer roleplay server. Year 10. Only what's left.
          </p>
        </div>

        <div className="flex flex-col gap-3 md:items-end">
          <a
            href={DISCORD_INVITE}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-discord-link"
            className="font-mono-ui text-xs uppercase tracking-[0.25em] text-[#C0A875] hover:text-[#E2E4DF] transition-colors"
          >
            JOIN DISCORD →
          </a>
          {isAdmin && (
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-[#8D9A87] hover:text-[#C0A875] transition-colors inline-flex items-center gap-2"
            >
              // ADMIN CONSOLE
              {pending > 0 && (
                <span
                  data-testid="admin-pending-badge"
                  className="relative inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 bg-[#C0392B] text-[#E2E4DF] font-mono-ui text-[9px] tracking-[0.15em] rounded-sm"
                >
                  <span className="absolute inset-0 rounded-sm bg-[#C0392B] animate-ping opacity-70" />
                  <span className="relative">{pending} NEW</span>
                </span>
              )}
            </Link>
          )}
          <span className="label-tag">
            © YEAR 10 // BROADCAST FROM THE EXCLUSION ZONE
          </span>
        </div>
      </div>
    </footer>
  );
}
